<h2 mat-dialog-title>{{ 'assignment.phase.add_assignment_dialog.title' | transloco }}</h2>
<mat-dialog-content>
	<p style="padding-bottom: 1rem">{{ 'assignment.phase.add_assignment_dialog.message' | transloco }}</p>
	<form [formGroup]="form">
		<mat-radio-group formControlName="targetPhaseId">
			<mat-radio-button value="3" [disabled]="!canMoveToP2">{{
				'assignment.phase.add_assignment_dialog.p2' | transloco
			}}</mat-radio-button>
			<mat-radio-button value="4" [disabled]="!canMoveToP3">{{
				'assignment.phase.add_assignment_dialog.p3' | transloco
			}}</mat-radio-button>
		</mat-radio-group>

		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				[type]="'button'"
				(clicked)="self.close()"
				icon="disabled_by_default"
			>
			</lvr-button>
			<lvr-button
				variant="primary"
				[label]="'base.button.add' | transloco"
				[type]="'button'"
				[disabled]="form.invalid"
				(clicked)="submit()"
				icon="add"
			>
			</lvr-button>
		</mat-dialog-actions>
	</form>
</mat-dialog-content>
